export const CONTACT_UPDATE_INITIAL_STATE = { phone: '', whatsappConfirmation: false, email: '' }
